/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable-next-line no-unused-vars */
import { Route, Routes } from 'react-router-dom';

import LandingPage from 'pages/LandingPage';
import ProjectPage from 'pages/ProjectPage';
import NotFoundPage from 'pages/NotFoundPage';
import BlogPage from 'pages/BlogPage';
import BlogDetailPage from 'pages/BlogDetailPage';

import { ProjectDetailPage } from 'pages/ProjectDetailPage';
import { DigitalProductPage } from 'pages/DigitalProductPage';

import FloatingWhatsapp from 'parts/FloatingWhatsapp';

import './assets/css/styles.css';

function App() {
  return (
    <>
      <FloatingWhatsapp />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/project" element={<ProjectPage />} />
        <Route path="/project/:id" element={<ProjectDetailPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogDetailPage />} />
        <Route path="/produk-digital" element={<DigitalProductPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
